/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_MembersInputs */

const cs_settings_teams_members = /** @type {(inputs: Settings_Teams_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Členové`)
};

const en_settings_teams_members = /** @type {(inputs: Settings_Teams_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Settings_Teams_MembersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_members = /** @type {((inputs?: Settings_Teams_MembersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_MembersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_members(inputs)
	return cs_settings_teams_members(inputs)
});